import * as React from 'react';
import Layout from '../Layout/Layout';

export default function Directory() {
  return (
    <Layout pageTitle='Company Registry'>
    </Layout>
  );
}
